import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import * as _ from 'lodash';
import { ApiService } from 'src/app/services/services.service';
import { Subjects } from 'src/app/utils/subjects';

@Component({
  selector: 'app-check-option',
  templateUrl: './check-option.component.html',
  styleUrls: ['./check-option.component.scss']
})
export class CheckOptionComponent implements OnInit {

  
  @Input() element: any;
  @Input() element_type: any;
  @Input() actualPlaceId;
  @Input() plural_context;
  @Input() context;
  @Input() causes;

  @Output() spin: EventEmitter<any> = new EventEmitter();

  options: any[];
  defaultColor = '#ccc';
  checked = false;
  showColor = true;
  items: any = []
  id_cause: number;
  tooltipColor: any = "No evaluado";

  constructor(
    private service: ApiService,
    private subject: Subjects,
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes['element']) {
      // console.log("this context ? ", this.plural_context);
      this.options = this.causes;
      // console.log("this options ? ", this.options);
      this.setToggles()
    }
  }

  setToggles() {
    // set default toggles 
    // let currentTogglesToSet = this.subject.currentItems$.getValue();
    let currentTogglesToSet = this.subject.metricDataSubject$.getValue()[this.plural_context];
    // console.warn("Get current toggles to set  ", currentTogglesToSet); 
    let actualPlaceId = this.actualPlaceId.value; 
    let place_obj = _.find(currentTogglesToSet, function (obj) {
      if (obj.place_id === actualPlaceId) { // Use the stored actualPlaceId here
        return true; // Return true to indicate a match
      }
    });
    if (place_obj){
      currentTogglesToSet = place_obj.items;
    }

    if (currentTogglesToSet != null && currentTogglesToSet.length > 0) {
      //// console.log("if statemet passing != null and > 0 ");

      for (let i = 0; i < currentTogglesToSet.length; i++) {
        //// console.log("inside for ", currentTogglesToSet[i]);
        let current = currentTogglesToSet[i];
        //// console.log("if statemet current.element and element.id", current.element , this.element.id);
        // console.log("- current elements to set ", current);
        // console.log("- element id ? - item_type : ", this.element.id, this.element_type)
        if (current.element === this.element.id && current.item_type_code === this.element_type) {
          // console.log("current elements to set ", current);
          this.setToggleStatus(current);
        }
      }
    } else {
      //console.log("current toggles of default ")
    }
  }

  setToggleStatus(current: any) {
    console.log('setToggleStatus check-option =>', this.context);

    // we set the toggles that was charged on our data.
    if (current.display_on === true) {
      this.checked = true;
      this.showColor = false;
      this.tooltipColor = "Completado";
    } else {
      if (current.cause_off === 1 || current.cause_off === 4 || current.cause_off === 7 || current.cause_off === 10) {
        this.id_cause = current.cause_off;
        this.defaultColor = 'red';
        let colorOptions = this.options;
        this.tooltipColor = colorOptions[0].name;
        // console.log("color options ", colorOptions);
      } else {
        if (current.cause_off === 2) {
          this.id_cause = 2;
          this.defaultColor = 'yellow';
          let colorOptions = this.options;
          this.tooltipColor = colorOptions[1].name;
        } else {
          this.defaultColor = '#3AB4E8'
          this.id_cause = 3;
          let colorOptions = this.options;
          this.tooltipColor = colorOptions[2].name;
        }
      }
    }
  }

  selectedColor(color: string) {
    console.log('selectedColor check-option =>', this.context);

    // 
    this.subject.spinnerTable$.next(true);

    let currentPlaceId = this.actualPlaceId.getValue();

    // if the color already exist will be eliminated
    this.validateIfColorExist();
    let flag = false;

    // knowing what's color was selected
    if (color === 'blue_light') {
      // console.log("COLOR SELECTED : BLUE LIGHT !!!!")
      this.defaultColor = '#3AB4E8'
      this.id_cause = 3;
      let colorOptions = this.options;
      this.tooltipColor = colorOptions[2].name;
    } else {
      if (color === 'red') {
        // console.log("COLOR SELECTED defautl: !!!!   REEED");
        // this.id_cause = 1;
        this.id_cause = this.options[0].id;
        this.defaultColor = color;
        let colorOptions = this.options;
        this.tooltipColor = colorOptions[0].name;
      } else {
        if (color === 'yellow') {
          // console.log("COLOR SELECTED defautl: Yellow!!!!");
          this.id_cause = 2;
          this.defaultColor = color;
          let colorOptions = this.options;
          this.tooltipColor = colorOptions[1].name;
        }
      }
    }
    //// console.log("element : ", this.element);
    //// console.log("element tyoe : ", this.element_type)
    //// console.log("color -------------------->>>>>>>", color);
   
    console.log("element checkkk", this.element);

    let object = {
      element: this.element.id,
      item_type_code: this.element_type,
      display_on: false,
      cause_off: this.id_cause,
    }

    let placeItems: any = this.subject.getElementItem(this.element.id, this.plural_context, currentPlaceId);
    console.log("place item return", placeItems)
    _.forEach(placeItems, (value, key) => {
      console.log("places items ", value, key);
      if(value.image){
        object['image'] = value.image;
        object['comment'] = value.comment;
      }
    })

    // let object = this.element;

    // object['display_on'] = false;
    // object['cause_off'] = this.id_cause;


    setTimeout(() => {
      // console.log("Delayed for 1.5 second.");
      this.subject._nextMetricPlaceDevice(currentPlaceId, null, null, null, object, this.plural_context)
    }, 10);
    

    // console.log("subject before color setting : ", this.subject.metricDataSubject$.getValue());

  }

  validateIfColorExist() {
    console.log('validateIfColorExist check-option =>', this.context);

    let currentPlaceId = this.actualPlaceId.getValue();
    let subject = _.cloneDeep(this.subject.metricDataSubject$.getValue());
    // let subject = this.subject.metricDataSubject$.getValue();

    //console.log("subject -> ", subject)
    // delete if passing false to true and it was setted a color (red, yellow or blue)
    let elementX = subject[this.plural_context];
    for (let item of elementX) {
      //console.log("item of subject devices : ", item);
      if (item.place_id === currentPlaceId) {
        for (let i = 0; i < item.items.length; i++) {
          if (item.items[i].element === this.element.id && item.items[i].item_type_code === this.element_type) {
            let element = item.items;
            element.splice(i, 1);
            break;
          }
        }
        break;
      }
    }
    this.subject.metricDataSubject$.next(subject);
  }


  onToggleChange(event: any, defaultItems: null) { 
    console.log('onToggleChange check-option =>', this.context);
    this.subject.spinnerTable$.next(true);
    let flag = false;
    // if event is true the color is setted as green and cause_off to null
    console.log("event .checked => ", event);
    if ((event.checked) || defaultItems != null) {
      this.showColor = false;
      this.tooltipColor = "Completado";
      let currentPlaceId = this.actualPlaceId.getValue();

      let subject = this.subject.metricDataSubject$.getValue();
      console.warn("subject from circle option component -> ", subject);
      // delete if passing false to true and it was setted a color (red, yellow or blue)
      let elementX = subject[this.plural_context];
      let item_ = {

      }
      for (let item of elementX) {
        if (item.place_id === currentPlaceId) {
          for (let i = 0; i < item.items.length; i++) {
            if (item.items[i].element === this.element.id && item.items[i].item_type_code === this.element_type) {
              item_ = _.cloneDeep(item.items[i]);
              let element = item.items;
              element.splice(i, 1);
              console.log("element => ", element);
              break;
            }
          }
        }
      }
      
      let item = item_;
      item['display_on'] = true;
      item['cause_off'] = null;
      item['element'] = this.element.id;
      item['item_type_code'] = this.element_type;


      // let item = {
      //   element: this.element.id,
      //   item_type_code: this.element_type,
      //   display_on: true,
      //   cause_off: null,
      // }

      
      console.log("item .checked => ", item);

      setTimeout(() => {
        // console.log("Delayed for 1.5 second.");
        this.subject._nextMetricPlaceDevice(currentPlaceId, null, null, null, item, this.plural_context)
      }, 10);

    } else {
      // when toggle is passing from true to false we delete the actual item of the element 
      // we set a default color and we show the mat menu option
      this.defaultColor = '#ccc';
      this.showColor = true;
      this.tooltipColor = "No evaluado";
      let currentPlaceId = this.actualPlaceId.getValue();
      let subject = this.subject.metricDataSubject$.getValue();

      // search the true element to delete and set with the disabled toggle value
      let elementX = subject[this.plural_context];
      for (let item of elementX) {
        if (item.place_id === currentPlaceId) {
          for (let i = 0; i < item.items.length; i++) {
            // fuound the element by his ID and by the type_code (displayed or card)
            if (item.items[i].element === this.element.id && item.items[i].item_type_code === this.element_type) {
              let element = item.items;
              element.splice(i, 1);
            }
          }
        }
      }
      // update the subject without the deleted element
      //console.log("updated element from true to false ", this.subject.metricDataSubject$.getValue());
      setTimeout(() => {
        // console.log("Delayed for 1.5 second.");
        this.subject.metricDataSubject$.next(subject);
      }, 10);
      
    }

    // this.postInformation();

  }

}
